import React from 'react';
import { render } from 'react-dom';
import Application from './components/Application.jsx';
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import './styles/global.scss';

render(
  <Router>
    <Application />
  </Router>
  , document.getElementById('root'));